import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1204113841849315';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
function loadMetaPixel() {
  const metaWindow = window as Window & {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  };
  if (metaWindow.fbq) return;
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args);
      return;
    }
    pixel.queue.push(args);
  } as MetaPixelFunction;
  pixel.queue = [];
  pixel.push = (...args: unknown[]) => pixel.queue.push(args);
  pixel.loaded = true;
  pixel.version = '2.0';
  metaWindow.fbq = pixel;
  metaWindow._fbq = pixel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  pixel('init', META_PIXEL_ID);
  pixel('track', 'PageView');
  const fallback = document.createElement('img');
  fallback.width = 1;
  fallback.height = 1;
  fallback.alt = '';
  fallback.style.display = 'none';
  fallback.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
  document.body.appendChild(fallback);
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" data-mp="2zm4vedw4z0yn" />;
}